module.exports = __webpack_public_path__ + "img/img71.5d2654e9.svg";